import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		'ddc.link.generic': [...mycarsSrpVdp['ddc.link.generic']],
		widgetUserEvent: [
			...mycarsSrpVdp.widgetUserEvent,
			{
				logic: {
					eventName: 'DR_CREDIT_APP_SUCCESS_DISPLAYED'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.applyForCredit]]'
					]
				}
			},
			{
				logic: {
					eventName: 'DR_TRADEIN_ESTIMATE_RECEIVED'
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'value trade in',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					zip_code: '[[eventData.zip]]',
					site_events: {
						value_trade_in: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					eventName: 'DR_TEST_DRIVE_REQUESTED'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.scheduleTestDrive]]'
					]
				}
			},
			{
				logic: {
					eventName: 'DR_DOWN_PAYMENT_CHANGED'
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'personalize payment',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					zip_code: '[[eventData.zip]]',
					site_events: {
						request_a_quote: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					widgetName: 'ws-vehicle-media',
					element: 'Photo Carousel'
				},
				payload: {
					category: 'engagement',
					action: 'link click',
					label: 'image',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						media_image_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: ({ eventData }) => {
					if (eventData?.widgetName === 'ws-vehicle-gallery') {
						return (
							eventData?.element === 'On Page Gallery photo' ||
							eventData?.element.includes('Photo Carousel')
						);
					}
					return false;
				},
				payload: {
					category: 'engagement',
					action: 'link click',
					label: 'image',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						media_image_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					eventName: 'DR_SUBMIT_OFFR_BTTN_CLICKED'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'buy online',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						buy_online: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					eventName: 'DR_OFFER_SUBMISSION_CLICKED'
				},
				payload: {
					shared: ['[[mapping.configuration.sharedPayloads.vraq]]']
				}
			},
			{
				logic: {
					eventName: 'DR_RM_NEW_TRADE'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'value trade-in',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						value_trade_in_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					eventName: 'DR_CREDIT_APP_DISPLAYED'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'apply for credit',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						apply_for_credit_click: true
					},
					site_provider: 'ddc'
				}
			}
		]
	}
};
